import { authenticatedApi } from '../api';

export const API_COMMENTS_PATH = '/channel/comments';

export const fetchPostComments = (postId) => authenticatedApi.get(
	`${API_COMMENTS_PATH}/post/${postId}`,
);

export const createPostComment = (comment) => authenticatedApi.post(
	`${API_COMMENTS_PATH}/post`,
	comment,
);

export const deletePostComment = (commentId) => authenticatedApi.delete(
	`${API_COMMENTS_PATH}/post/${commentId}`,
);

export const updatePostComment = ({ id, text, images, videos }) => authenticatedApi.put(
	`${API_COMMENTS_PATH}/post/${id}`,
	{ text, images, videos },
);

export const likePostComment = (commentId) => authenticatedApi.post(
	`${API_COMMENTS_PATH}/post/${commentId}/like`,
);

export const unLikePostComment = (commentId) => authenticatedApi.post(
	`${API_COMMENTS_PATH}/post/${commentId}/unlike`,
);
